<template>
  <div id="app">
    <header-actions id="globalHeader" v-if="!hideHeaderPaths.includes($route.path)" class="global-header-actions" />
    <router-view />
    <fail-notify-container v-if="!hideOverlayPaths.includes($route.path)" />
    <ai-sidebar v-if="!hideOverlayPaths.includes($route.path)" />
    <canvas-launcher v-if="showCanvasLauncher" />
    <qywx-bind-dialog :visible="showQywxBind" @bind-success="onBindSuccess" />
  </div>
</template>

<script>
import HeaderActions from '@/views/xiaoyunque/components/HeaderActions.vue'
import FailNotifyContainer from '@/views/xiaoyunque/components/FailNotifyContainer.vue'
import AiSidebar from '@/views/components/AiSidebar.vue'
import CanvasLauncher from '@/views/components/CanvasLauncher.vue'
import QywxBindDialog from '@/views/components/QywxBindDialog.vue'
import { getCurrentUser } from '@/api/c/auth'
import { getToken } from '@/utils/auth'

export default {
  name: 'App',
  components: { HeaderActions, FailNotifyContainer, AiSidebar, CanvasLauncher, QywxBindDialog },
  data() {
    return {
      hideHeaderPaths: ['/login', '/xiaoyunque/index', '/xiaoyunque/myProject', '/xiaoyunque/canvas'],
      hideOverlayPaths: ['/xiaoyunque/canvas'],
      showQywxBind: false,
    }
  },
  computed: {
    showCanvasLauncher() {
      const projectCanvasPaths = [
        '/xiaoyunque/detail/script',
        '/xiaoyunque/detail/script_new',
        '/xiaoyunque/detail/scenes',
        '/xiaoyunque/detail/video',
        '/xiaoyunque/edit',
        '/xiaoyunque/myAssets',
      ]
      return process.env.VUE_APP_AI_CANVAS_ENABLED !== 'false'
        && Boolean(getToken())
        && projectCanvasPaths.includes(this.$route.path)
        && Boolean(this.$route.query.id)
    },
  },
  mounted() {
    // 首次加载主动检查绑定状态
    if (getToken()) {
      getCurrentUser().then(res => {
        if (res && res.data) {
          this.checkOaBind(res.data)
        }
      }).catch(() => {})
    }
    // 后续每次路由切换后也检查（router.afterEach 触发）
    this.$on('user-profile-updated', this.checkOaBind)
  },
  methods: {
    checkOaBind(user) {
      if (!user || user.oaUid) return
      // 仅指定团队的用户需要绑定企微，通过环境变量配置控制
      const requiredTeam = process.env.VUE_APP_QYWX_BIND_TEAM
      console.log('[QywxBind] team=', user.team, 'requiredTeam=', requiredTeam, 'env=', process.env)
      if (requiredTeam != null && String(user.team) !== String(requiredTeam)) return
      this.showQywxBind = true
    },
    onBindSuccess() {
      this.showQywxBind = false
    }
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
}

.global-header-actions {
  position: fixed;
  right: 24px;
  top: 13px;
  z-index: 1000;
}
.el-message {
  top: 60px !important;
}
body.ai-sidebar-open .global-canvas-launcher {
  right: min(420px, 92vw);
}
</style>
